import { gql } from '@apollo/client';

export const UPDATE_MY_PROFILE_DETAILS_MUTATION = gql`
  mutation updateMyProfileDetails($input: UpdateProfileDetails!) {
    updateMyProfileDetails(input: $input)
  }
`;
